import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import ScreenBanner from "../../../../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas";
import AddIcon from "@mui/icons-material/Add";
import SessaoConfiguracao from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import DialogIncluirEditarCultura from "../DialogIncluirEditarCultura";
import { useCallback, useState } from "react";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";

export interface ICultura {
    id: number;
    nome: string;
}

export default function ListagemCulturas() {

    const listaAcoesRapidas: Array<TItemAcaoRapida> = [
        {
            label: `Incluir cultura`,
            icon: <AddIcon color="primary" />,
            action: () => handleModalAction("open", true, null),
            havePermission: usePermission('receituario.incluir-cultura'),
        }
    ];

    const [openModal, setOpenModal] = useState<TOpenModalCulturas>(null)
    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: ICultura | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    function RenderListagem() {
        return (
            <>
                <SessaoConfiguracao<ICultura>
                    titulo="Lista de culturas"
                    endpoints={{
                        listar: "/receituario-agronomico/culturas/pesquisar-cultura",
                        deletar: "/receituario-agronomico/culturas/excluir-cultura",
                    }}
                    possuiAdicionar={false}
                    colunas={colunas}
                    queryKey="pesquisar-culturas"
                    onEditar={(culturas) => {
                        handleModalAction("open", culturas.id, culturas)
                    }}
                    onAdicionar={() => {
                        handleModalAction("open", true, null)
                    }}
                    mensagemSucessoDeletar="Cultura deletado com sucesso!"
                    mensagemErroDeletar="Erro ao deletar cultura!"
                    mensagemSemDados="Nenhuma cultura encontrado."
                />
            </>
        );
    }

    return (
        <>
            <ScreenBanner title="Receituário Agronômico" />
            <PermissionGuard permissionId="receituario.listar-culturas">
                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5">Culturas</Typography>
                    <Grid container spacing={2} mt={1}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                                fullHeight={false}
                            />
                        </Grid>
                        <Grid size={{xs: 12, md: 9}}>
                            <Box component={Paper}>
                                <Box px={2} pb={2}>
                                    <RenderListagem />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
                {
                    !!openModal &&
                    <DialogIncluirEditarCultura
                        defaultValue={openModal?.defaultValue ? openModal : null}
                        open={!!openModal}
                        handleClose={() => handleModalAction("close", true)} />
                }
            </PermissionGuard>
        </>
    );
}

export type TOpenModalCulturas = {
    open: number | boolean | null;
    defaultValue: ICultura | null;
} | null
const colunas = [
    {
        campo: "nome" as keyof ICultura,
        titulo: "Nome",
    },
];